import React from 'react'
import { Field } from 'formular'

import links from 'links'

import { Checkbox } from 'components/inputs'


type AgreementCheckProps = {
  className?: string
  field: Field<boolean>
}

const message = `Даю <Link toTab="${links.agreement}" title="согласие" color="alien" /> на обработку моих персональных данных
 в соответствии с <Link toTab="${links.policy}" title="политикой" color="alien" /> в отношении обработки персональных данных`

const AgreementCheck: React.FC<AgreementCheckProps> = (props) => {
  const { className, field } = props

  return (
    <div className={className}>
      <Checkbox
        className="mt-2px"
        field={field}
        label={message}
      />
    </div>
  )
}

export default AgreementCheck